import React from "react";
import "../Styles/Contact.css";

const Contact = () => {
  return (
    <>
    
    <div className="contact-image">
      <img src="./corporate/connect.png " alt="" />
    </div>

    <section className="contact-section">
      <h1 className="contact-title">Contact Us</h1>

      {/* TOP INFO BOXES */}
      <div className="info-grid">
        <div className="info-card">
          <h4>Head Office</h4>
          <p>
            Plot No. 14 & 15, First Floor, Gajraj Apartment, Opp. Neelam Hotel,
            Motilal Atal Road, Jaipur – 302001, Rajasthan.
          </p>
        </div>

        <div className="info-card">
          <h4>Phone</h4>
          <p>0141-4025773</p>
        </div>

        <div className="info-card">
          <h4>Email</h4>
          {/* <p>info@swastikainfra.com</p> */}
          <a href="https://mail.google.com/mail/?view=cm&fs=1&to=info@swastikainfra.com&su=Job Application" target="_blank" rel="noopener noreferrer" style={{color: "#555" , textDecoration: "none"}} >
          info@swastikainfra.com
        </a>
        </div>

        <div className="info-card">
          <h4>CIN</h4>
          <p>U51909RJ2019PLC065892</p>
        </div>
      </div>

      {/* MAP + FORM */}
      <section className="map-form-wrapper" id="map">
        

        {/* FORM */}
        {/* <div className="contact-form">
          <h3>Let’s Connect</h3>
          <p>
            Please connect with us for project inquiry, feedback or grievance.
          </p>

          <form>
            <input type="text" placeholder="Name" />
            <input type="email" placeholder="Email Address" />
            <textarea placeholder="Message" rows="5"></textarea>
            <button type="submit">SUBMIT</button>
          </form>
        </div> */}

        
      </section>
        {/* MAP */}
        <div className="map-box">
       
          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7114.94779851261!2d75.798571!3d26.920187!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db3f88e99c713%3A0x4100ab9bd4cf88a1!2sSwastika%20Infra%20Limited!5e0!3m2!1sen!2sin!4v1768898834777!5m2!1sen!2sin"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title="address"></iframe>
        </div>
    </section>

    </>
  );
};

export default Contact;
